
// Input directive - add focus to field
export const Focus = {
    inserted: function (el) {
        setTimeout(() => el.focus(), 500)
    }
}

// Input directive - used to float up labels next to input field
// this simply adds a class on blur if input is not empty
export const Floatable = {
    inserted: function (el) {
        var check = function() {
            var isFilled = el.value !== ''
            if (isFilled) {
                el.classList.add('filled')
            } else {
                el.classList.remove('filled')
            }
        }

        el.addEventListener('blur', () => check());
        check();
    }
}



// WEBPACK FOOTER //
// ./src/directives/directives.js